"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/modal/style");
var _modal = _interopRequireDefault(require("antd/lib/modal"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../utils");
var _components = require("../../../components");
var _lodash = require("lodash");
var _util = require("../../GroupList/util");
require("./GroupVideoWelcomeModal.less");
var _AuthProvider = require("../../AuthProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var GroupVideoWelcomeModal = function GroupVideoWelcomeModal(_ref) {
  var group = _ref.group,
    session = _ref.session,
    hide = _ref.hide,
    visible = _ref.visible,
    nickName = _ref.nickName,
    _ref$isClinician = _ref.isClinician,
    isClinician = _ref$isClinician === void 0 ? false : _ref$isClinician;
  var _useAuth = (0, _AuthProvider.useAuth)(),
    user = _useAuth.user;
  var name = group.name,
    clinician = group.clinician,
    isWebinar = group.isWebinar,
    groupSessions = group.groupSessions;
  var firstName = clinician.firstName,
    lastName = clinician.lastName;
  var clinicianName = (0, _utils.composeName)([firstName, lastName], ' ');
  var isChromeOnIOS = (0, _utils.chromeOnIOS)();
  var userHasVideoAndAudioControls = isWebinar ? (0, _util.isUserWebinarGroupModerator)(user === null || user === void 0 ? void 0 : user.accountId, group, session) : true;

  // 3rd party video provider, Daily, doesn't support Chrome on iOS
  if (isChromeOnIOS) {
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      centered: true,
      visible: visible,
      footer: null,
      closable: false,
      maskClosable: false,
      destroyOnClose: true,
      onCancel: hide
    }, "Peer support video sessions aren\u2019t currently available in Chrome on iOS, please use Safari.");
  }
  return /*#__PURE__*/_react.default.createElement(_modal.default, {
    className: "group-intro-modal",
    centered: true,
    visible: visible,
    footer: null,
    closable: true,
    maskClosable: false,
    destroyOnClose: true,
    onCancel: hide
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-body-lg-light text-black mx-[12px]"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "tw-subtitle-lg-light"
  }, name), /*#__PURE__*/_react.default.createElement("p", {
    className: "mt-[18px]"
  }, "Moderator: ", /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-lg-regular"
  }, clinicianName)), /*#__PURE__*/_react.default.createElement("p", {
    className: "mt-[18px]"
  }, "We\u2019re so glad you\u2019re here!"), isClinician ? /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-lg-regular mt-[18px]"
  }, "RSVP count: ", (0, _lodash.isEmpty)(groupSessions) ? 'N/A' : groupSessions[0].rsvpCount) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    className: "mt-[18px]"
  }, "You are entering the chat with your anonymous community nickname:"), /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-lg-regular mt-[6px]"
  }, nickName)), /*#__PURE__*/_react.default.createElement("p", {
    className: "mt-[18px]"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-lg-regular"
  }, "Your microphone and camera are set to off"), userHasVideoAndAudioControls ? ', and you can turn either on if you want to.' : '. You may participate in the chat.'), /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    size: "large",
    className: "w-full mt-[32px] mb-[18px]",
    onClick: hide
  }, "Join session")));
};
GroupVideoWelcomeModal.propTypes = {
  group: _propTypes.default.object,
  session: _propTypes.default.object,
  hide: _propTypes.default.func,
  visible: _propTypes.default.bool,
  nickName: _propTypes.default.string,
  isClinician: _propTypes.default.bool
};
var _default = GroupVideoWelcomeModal;
exports.default = _default;